import React from "react";
import { Input, Form, Switch, Typography, Select, Tag, Button, Space, Row, Col } from "antd";
import { CompassOutlined } from "@ant-design/icons";

const { Text } = Typography;

const FormFields = ({ form }) => {
  // Détecte automatiquement les coordonnées si l'admin clique sur le bouton
  const handleAutoDetectCoords = () => {
    const address = (form.getFieldValue("address") || "").toLowerCase();
    
    if (address.includes("uma")) {
      form.setFieldsValue({ latitude: "36.8685", longitude: "10.2220" });
    } else if (address.includes("platon") || address.includes("charguia")) {
      form.setFieldsValue({ latitude: "36.8485", longitude: "10.2075" });
    } else if (address.includes("centre urbain nord")) {
      form.setFieldsValue({ latitude: "36.8450", longitude: "10.1980" });
    } else if (address.includes("bab bhar")) {
      form.setFieldsValue({ latitude: "36.7992", longitude: "10.1802" });
    } else if (address.includes("montplaisir")) {
      form.setFieldsValue({ latitude: "36.8175", longitude: "10.1895" });
    } else if (address.includes("ariana")) {
      form.setFieldsValue({ latitude: "36.8665", longitude: "10.1956" });
    } else {
      form.setFieldsValue({ latitude: "36.8065", longitude: "10.1815" });
    }
  };

  return (
    <>
      <Form.Item
        name="firstName"
        label="Prénom"
        rules={[{ required: true, message: "S'il vous plaît entrer le prénom" }]}
      >
        <Input placeholder="Prénom" />
      </Form.Item>

      <Form.Item
        name="lastName"
        label="Nom de famille"
        rules={[{ required: true, message: "S'il vous plaît entrer le nom de famille" }]}
      >
        <Input placeholder="Nom de famille" />
      </Form.Item>

      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true, type: "email", message: "Email valide requis" }]}
      >
        <Input placeholder="Email" />
      </Form.Item>

      <Form.Item
        name="phone"
        label="Téléphone"
        rules={[{ required: true, message: "Numéro de téléphone requis" }]}
      >
        <Input placeholder="Téléphone" />
      </Form.Item>

      {/* CHAMP ADRESSE */}
      <Form.Item
        name="address"
        label="Adresse"
        rules={[{ required: true, message: "Adresse requise" }]}
      >
        <Input placeholder="Ex: 42 Av. de l'UMA, Ariana 2036" />
      </Form.Item>

      {/* CHAMPS LATITUDE & LONGITUDE AVEC BOUTON DÉTECTION AUTO */}
      <Form.Item label="Coordonnées GPS">
        <Row gutter={8} align="middle">
          <Col span={9}>
            <Form.Item name="latitude" noStyle>
              <Input placeholder="Latitude (ex: 36.8685)" />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item name="longitude" noStyle>
              <Input placeholder="Longitude (ex: 10.2220)" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Button 
              type="dashed" 
              icon={<CompassOutlined />} 
              onClick={handleAutoDetectCoords}
              title="Calculer depuis l'adresse"
            >
              Détecter
            </Button>
          </Col>
        </Row>
      </Form.Item>

      {/* GAMME / CATÉGORIE */}
      <Form.Item name="category" label="Gamme / Catégorie">
        <Select placeholder="Choisir une gamme" allowClear style={{ width: '100%' }}>
          <Select.Option value="AKTIV"><Tag color="blue">AKTIV</Tag></Select.Option>
          <Select.Option value="SANOSAN"><Tag color="green">SANOSAN</Tag></Select.Option>
          <Select.Option value="MATERNITE"><Tag color="purple">MATERNITE</Tag></Select.Option>
        </Select>
      </Form.Item>

      {/* HORS STATISTIQUES */}
      <Form.Item name="excludeFromStats" label="Hors Statistiques" valuePropName="checked">
        <Switch checkedChildren="OUI" unCheckedChildren="NON" danger />
      </Form.Item>
      <div style={{ marginLeft: '33.3%', marginBottom: '20px' }}>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          * Si activé, ce délégué n'apparaîtra plus dans le Dashboard.
        </Text>
      </div>
    </>
  );
};

export default FormFields;